import React from 'react'
import PropTypes from 'prop-types'
import './TitleStep.sass'

const TitleStep = ({
  term ,
  price ,
  titleCaption,
  titleInfo,
  color
}) => (
  <section className="titleStep">
    <p className="titleStep__text"><span className="titleStep__text-bold">Сроки оказания услуги:</span>{term}.</p>
    {/* eslint-disable */}
    <p className="titleStep__text" dangerouslySetInnerHTML={{__html:price && `<span class="titleStep__text-bold">Стоимость услуги:</span>${price}` }} />
    {/* eslint-disable */}
    <ul className={`titleStep__list ${color}`}>
      <li className="list__caption">{titleCaption && titleCaption}</li>
      <li className="list__content">{titleInfo && titleInfo}</li>
    </ul>
  </section>
)

TitleStep.propTypes = {
  term: PropTypes.string,
  price: PropTypes.string.isRequired,
  titleCaption: PropTypes.string.isRequired,
  titleInfo: PropTypes.string.isRequired,
  color: PropTypes.string
}

TitleStep.defaultProps = {
  term: '30 дней',
  color: 'primary'
}

export default TitleStep



// WEBPACK FOOTER //
// ./components/Service_TitleStep/index.jsx